module.exports = {
  formData: {
    campaignTitle: '',
    totalBudgetStr: 0,
    totalBudget: 0,
    startDate: '',
    endDate: '',
    simulationTitle: '',
    advertiger: '',
    agency: '',
    industry: '',
    age: "769",
    minAge:7,
    maxAge:69,
    gender:'MF',
    genderLabel:'MF769',
    // outputTarget: 'MF769',
    // outputTarget_cnt: 0,
    targetCode: 'MF769',
    demographic_cnt: 0,
    mediaList: null, // 예산최적화 '겸용'
    channelList: null, // 예산안 최적화용
    // completeCalculcation : false,
    mediaListResult : null, // 예산최적화 '겸용'
    channelListResult : null, // 예산안최적화용
    completeChannelLevelCalculcation : false,
    montlyAllocation:false, // 예산안최적화용
    monthly1:0, // 예산안최적화용
    monthly2:0, // 예산안최적화용
    monthly3:0, // 예산안최적화용
    goalReach:65, // 예산안최적화용
    selectedAllocationMode:'maxReach', // 예산안최적화용
    selectedMediaOption:'media', // 예산안최적화용
    allocationPortionON:false, // 예산안최적화용
    activeMediaSelectForChannel:'mediaTV', // 예산안최적화용
  },
  mediaInfo: {
    rootIndex : null,
    vehicle_type : 'system',
    media: '',
    channel: '',
    vehicle: '',
    age: "769",
    minAge:7,
    maxAge:69,
    gender:'MF',
    genderLabel:'MF769',
    targetCode: 'MF769',
    outputTargetCode: 'MF769',
    demographic_cnt: 0,
    targetOnOff: true,
    budgetStr:0,
    budget:0,
    cpmStr: 0,
    cpm: 0,
    eImpStr: 0,
    eImp: 0,
    frequency: '미설정',
    mediaStartDate: '',
    mediaEndDate: '',
    formValidation:false,
    graphId:'1',
    grps: 0,
    reach1 : 0,
    // 계수 데이터, 분석결과도 여기에 append ??
    minmumAllocationPortion:10, // 예산안최적화용
    portionComparator:'<',
    budgetRatio:0,
    af : 0,
    ////////////////////////////////////////
    optionASelected: '일반',
    optionBSelected: '최상단',
    optionCSelected: '메인',
    optionDSelected: '일반',
    optionESelected: '이미지',
    bannerWidthStr: '1024',
    bannerHeightStr: '1080',
    bannerMsg:'',
  },
  inteMedia:{
      tvMedia:{
        inte_ModelCode:'',
        overall:null,
        mediaList: {},
        resultMedia:null,
        screenCount: 1,
      },
      mobileMedia :{
        inte_ModelCode:'',
        overall:null,
        mediaList: {},
        etcMediaList:[],
        resultMedia:null,
        screenCount: 1,
      },
      pcMedia:{
        inte_ModelCode:'',
        overall:null,
        mediaList: {},
        etcMediaList:[],
        resultMedia:null,
        screenCount: 1,
      },
      digitalMedia:{
        inte_ModelCode:'',
        overall:null,
        mediaList: {},
        etcMediaList:[],
        resultMedia:null,
        screenCount: 1,
      },
      totalMedia:{
        // inte_ModelCode:'',
        // overall:null,
        // mediaList: {},
        // etcMediaList:[],
        resultMedia:null,
        // screenCount: 1,
      },
  },
  historyData:{
    user_id : null,
    std_dt : null,
    view_name : null,
    view_cd : null,
    formData : null,
    bookMarked : false
  },
  calendarLocale : {
    "format": "YY/MM/DD",
    "separator": "~",
    "applyLabel": "적용",
    "cancelLabel": "취소",
    "fromLabel": "From",
    "toLabel": "To",
    "customRangeLabel": "Custom",
    "weekLabel": "W",
    "daysOfWeek": [
      "일", "월", "화", "수", "목", "금", "토"
    ],
    "monthNames": [
      "1월", "2월", "3월", "4월", "5월", "6월",
      "7월", "8월", "9월", "10월", "11월", "12월"
    ],
    "firstDay": 1
  },
  mediaStructure : {
    "TV": {
      "전체": ["전체"],
      "지상파": ["전체"],
      "케이블": ["전체"],
      "종편": ["전체"]
    },
    "PC": {
      "전체": ["전체"],
      "Youtube": ["전체", "Trueview_Instream", "Trueview_Discovery", "Bumper AD"],
      "SMR": ["전체"],
      "Facebook": ["전체"],
      "Daum": ["전체"],
      "Naver": ["전체"],
      "AfreecaTV": ["전체"],
      "PandoraTV": ["전체"],
      "GomTV": ["전체"],
      "SPOTV": ["전체"],
      "Tving": ["전체"],
      "Incross-다윈": ["전체"],
      "Mezzomedia-맨": ["전체"],
      "DMC-V1": ["전체"],
    },
    "Mobile": {
      "전체": ["전체"],
      "Youtube": ["전체", "Trueview_Instream", "Trueview_Discovery", "Bumper AD"],
      "SMR": ["전체"],
      "Facebook": ["전체"],
      "Daum": ["전체"],
      "Naver": ["전체"],
      "AfreecaTV": ["전체"],
      "PandoraTV": ["전체"],
      "GomTV": ["전체"],
      "SPOTV": ["전체"],
      "Tving": ["전체"],
      "Incross-다윈": ["전체"],
      "Mezzomedia-맨": ["전체"],
      "DMC-V1": ["전체"],
    },
    "Digital": {
      "전체": ["전체"],
      "Youtube": ["전체", "Trueview_Instream", "Trueview_Discovery", "Bumper AD"],
      "SMR": ["전체"],
      "Facebook": ["전체"],
      "Daum": ["전체"],
      "Naver": ["전체"],
      "AfreecaTV": ["전체"],
      "PandoraTV": ["전체"],
      "GomTV": ["전체"],
      "SPOTV": ["전체"],
      "Tving": ["전체"],
      "Incross-다윈": ["전체"],
      "Mezzomedia-맨": ["전체"],
      "DMC-V1": ["전체"],
    },
  },
  allocationMediaStructure : {
    "TV": {
      "지상파": [],
      "케이블": [],
      "종편": []
    },
    "PC": {
      "Youtube": [],
      "SMR": [],
      "Facebook": [],
    },
    "Mobile": {
      "Youtube": [],
      "SMR": [],
      "Facebook": [],
    },
    "Digital": {
      "Youtube": [],
      "SMR": [],
      "Facebook": [],
    },
  },
  ageList : [
    {min:7, max:69, point:0},
    {min:7, max:59, point:0},
    {min:7, max:49, point:0},
    {min:7, max:44, point:0},
    {min:7, max:39, point:0},
    {min:7, max:34, point:0},
    {min:7, max:29, point:0},
    {min:7, max:24, point:0},
    {min:7, max:18, point:0},
    {min:7, max:12, point:0},
    {min:60, max:69, point:0},
    {min:50, max:69, point:0},
    {min:50, max:59, point:0},
    {min:45, max:69, point:0},
    {min:45, max:59, point:0},
    {min:45, max:49, point:0},
    {min:40, max:69, point:0},
    {min:40, max:59, point:0},
    {min:40, max:49, point:0},
    {min:40, max:44, point:0},
    {min:35, max:69, point:0},
    {min:35, max:59, point:0},
    {min:35, max:49, point:0},
    {min:35, max:44, point:0},
    {min:35, max:39, point:0},
    {min:30, max:69, point:0},
    {min:30, max:59, point:0},
    {min:30, max:49, point:0},
    {min:30, max:44, point:0},
    {min:30, max:39, point:0},
    {min:30, max:34, point:0},
    {min:25, max:69, point:0},
    {min:25, max:59, point:0},
    {min:25, max:49, point:0},
    {min:25, max:44, point:0},
    {min:25, max:39, point:0},
    {min:25, max:34, point:0},
    {min:25, max:29, point:0},
    {min:19, max:69, point:0},
    {min:19, max:59, point:0},
    {min:19, max:49, point:0},
    {min:19, max:44, point:0},
    {min:19, max:39, point:0},
    {min:19, max:34, point:0},
    {min:19, max:29, point:0},
    {min:19, max:24, point:0},
    {min:13, max:69, point:0},
    {min:13, max:59, point:0},
    {min:13, max:49, point:0},
    {min:13, max:44, point:0},
    {min:13, max:39, point:0},
    {min:13, max:34, point:0},
    {min:13, max:29, point:0},
    {min:13, max:24, point:0},
    {min:13, max:18, point:0},
  ]
}



// WEBPACK FOOTER //
// ./src/views/common/ReachFormData.js